module.exports = __webpack_public_path__ + "img/img_yidong.7c6eba94.png";